import { DeviceUUID } from "device-uuid";

export function getUUID() {
  let ID = new DeviceUUID().get();
  ID = ID.replace(/-/g, "");
  //console.log("DEVICE-ID => ", ID);
  return ID;
}
